import http from '../http'

export default {
  info() {
    return http.get('/sysadmin/info')
  }
}


// WEBPACK FOOTER //
// ./src/service/apis/Version.js